module.exports = __webpack_public_path__ + "img/coupon-50.76478575.png";